import Dropdown from './Dropdown'




/* MENU DROPDOWN
----------------------------------------------------------------------------------------------------*/

export default class HeaderCart extends Dropdown {

    constructor($el) {
        super($el)
        this.$els.doc.on('close-cart', () => {
            this.toggle(false)
        })
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



